import type { ReportExportJob } from "../types";

export const MY_EXPORTS_POLL_MS = 3000;

/**
 * «O'z eksportlarim» ro'yxatining polling oralig'i (Task P3).
 *
 * ⚠️ Faqat ro'yxatda faol (`pending`/`processing`) job bo'lsa polling
 * qilinadi — aks holda markaz sahifasi ochiq turganda cheksiz so'rov
 * ketardi (`useReportExport` naqshi). Sof funksiya — hook'siz test
 * qilinadi.
 */
export function myExportsRefetchInterval(items: ReportExportJob[] | undefined): number | false {
	const faol = items?.some((job) => job.status === "pending" || job.status === "processing");

	return faol ? MY_EXPORTS_POLL_MS : false;
}
